import{e as p,g as c,m as e}from"./chunk-HBP5N4FR.js";var _={};c(_,{css:()=>o,default:()=>t});var o,t,d=p(()=>{e();o=`.dapp-core-component__styles__value .dapp-core-component__styles__price {
  color: #6c757d;
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(o));t={value:"dapp-core-component__styles__value",price:"dapp-core-component__styles__price"}});export{o as a,t as b,_ as c,d};
//# sourceMappingURL=chunk-YQMSWPSV.js.map
